module.exports = __webpack_public_path__ + "static/index-top-bg-7d7a3a97a7a875271fa448db99c2da8d.jpg";